import React, {useContext, useEffect, useMemo, useState} from "react"
import {
    Box,
    Button,
    ButtonGroup,
    Dialog, DialogActions, DialogContent, DialogContentText,
    DialogTitle,
    ToggleButton,
    ToggleButtonGroup,
    Tooltip,
    Typography,
} from "@mui/material"
import {AppDataContext} from "../../../../App";
import {
    BorderHorizontal as BorderHorizontalIcon,
    BorderVertical as BorderVerticalIcon
} from "@mui/icons-material";
import {Direction, ViewMode} from "../../../../data/app/state";
import "./header.css"
import _ from "lodash";
import PropTypes from "prop-types";
import {getAuth} from "firebase/auth"
import UseApiManager from "../../../manager/api"

const styles = {
    root: {
        display: 'flex',
        padding: '8px 16px',
        alignItems: 'center',
        gap: '1rem',
        background: '#4f85c9',
        boxShadow: '1px 1px 3px #6b6b6b',
    },
    title: {
        fontSize: '26px',
        fontWeight: 'bold',
        color: 'white',
        WebkitTextStroke: '1px #cdcdcd'
    },
    subTitle: {
        color: '#1332cb',
        fontWeight: 'bold',
        fontSize: '21px',
        textShadow: '1px 1px 0 #FFF, -1px -1px 0 #FFF, -1px 1px 0 #FFF, 1px -1px 0 #FFF, 0px 1px 0 #FFF,  0-1px 0 #FFF, -1px 0 0 #FFF, 1px 0 0 #FFF'
    },
    menuButton: {
        borderColor: 'white',
        color: '#333',
        background: '#eeeeee8c',
        margin: '0',
        padding: '4px 8px',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'row',
        gap: '4px',
    },
    toggleBase: {
        borderColor: 'white',
        padding: '6px 12px',
        color: '#333',
        background: '#eeeeee70'
    },
    exportExcelButton: {
        borderColor: 'white',
        color: 'white',
        background: '#eeeeee2e',
    },
    clearConditionButton: {
        borderColor: 'white',
        color: 'white',
        background: '#eeeeee2e',
    },
    viewModeToggleButtonGroup: {

    },
    viewModeToggleButton: {
        borderColor: 'white',
        color: 'white',
    },
    viewDirectionToggleButtonGroup: {

    },
    viewDirectionToggleButton: {
        borderColor: 'white',
        color: 'white',
    },
    logoutButton: {
        borderColor: 'white',
        color: 'white',
        background: '#eeeeee2e',
    },
    userAdminButton: {
        borderColor: 'white',
        background: '#f97272cc',
        color: 'white',
    }
}

const MainHeaderView = ({onExportExcel, onClearConditions, onUserAdmin}) => {

    const { state, setViewMode, setDirection } = useContext(AppDataContext)
    const [openConfirmLogout, setOpenConfirmLogout] = useState(false)
    const { GetOne } = UseApiManager()
    const [isAdminPermission, setIsAdminPermission] = useState()
    const title = useMemo(() => {
        let baseName = state.env.CLIENT_APP_TITLE ?? "街路樹台帳データベース"
        let envName = process.env.REACT_APP_ENV !== "production" ? `(${process.env.REACT_APP_ENV})` : ''
        return `${baseName}${envName}`.trim()
    }, [process.env.REACT_APP_ENV, state.env])

    const onViewModeChange = (_, value) => {
        setViewMode(value)
    }

    const onLogoutSubmit = () => {
        getAuth().signOut().then(() => {})
    }

    useEffect(() => {
        if (!state.user) { return }
        console.log("[Header]", "state.user", state.user)
        try {
            GetOne('user/check_permission', {
                type: "UserAdmin"
            }).then(setIsAdminPermission)
        } catch(e) {
            setIsAdminPermission(false)
        }
    }, [state.user])

    return (
        <Box style={styles.root}>
            <Typography style={styles.title}>{title}</Typography>
            <Typography style={styles.subTitle}>地図表示</Typography>
            <div style={{flexGrow: 1}} />
            <Button style={styles.menuButton} variant="outlined" onClick={onExportExcel}><img src="/resources/img/icon_excel.svg" alt="excel" />Excel出力</Button>
            <Button style={styles.menuButton} variant="outlined" onClick={onClearConditions}><img src="/resources/img/icon_condition_clear.svg" alt="clear" />条件クリア</Button>
            <ToggleButtonGroup className="header-toggle" size="small" value={state.viewMode} onChange={onViewModeChange}>
                <ToggleButton style={{...styles.toggleBase, borderRadius: "10px 0 0 10px"}} value={ViewMode.Map}>地図</ToggleButton>
                <ToggleButton style={{...styles.toggleBase, borderRadius: "0 10px 10px 0"}} value={ViewMode.List}>リスト</ToggleButton>
            </ToggleButtonGroup>
            <ToggleButtonGroup style={{opacity: _.size(state.viewMode) === 1 ? 0.3: 1}} disabled={_.size(state.viewMode) === 1} className="header-toggle" size="small" value={state.direction}>
                <ToggleButton
                    style={{
                        ...styles.toggleBase,
                        ...(state.direction === Direction.Vertical ? {background: "white"} : null),
                        borderRadius: "10px 0 0 10px"
                    }}
                    value={Direction.Vertical}
                    onClick={() => setDirection(Direction.Vertical)}
                >
                    <img src="/resources/img/icon_screen_vertical.svg" alt="vertical screen" style={{height: "24px"}} />
                </ToggleButton>
                <ToggleButton
                    style={{
                        ...styles.toggleBase,
                        ...(state.direction === Direction.Horizontal ? {background: "white"} : null),
                        borderRadius: "0 10px 10px 0"
                    }}
                    value={Direction.Horizontal}
                    onClick={() => setDirection(Direction.Horizontal)}
                >
                    <img src="/resources/img/icon_screen_horizontal.svg" alt="horizontal screen" style={{height: "24px"}} />
                </ToggleButton>
            </ToggleButtonGroup>
            {isAdminPermission && (
                <Button style={styles.menuButton} variant="outlined" onClick={() => onUserAdmin()}><img src="/resources/img/icon_user_admin.svg" alt="user_admin" />ユーザ管理</Button>
            )}
            <Button style={styles.menuButton} variant="outlined" onClick={() => setOpenConfirmLogout(true)}><img src="/resources/img/icon_logout.svg" alt="logout" />ログアウト</Button>
            <Dialog open={openConfirmLogout}>
                <DialogTitle>ログアウト</DialogTitle>
                <DialogContent>
                    <DialogContentText>本当にログアウトしますか</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onLogoutSubmit}>ログアウト</Button>
                    <Button onClick={() => setOpenConfirmLogout(false)}>キャンセル</Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}

MainHeaderView.propTypes = {
    onExportExcel: PropTypes.func.isRequired,
    onClearConditions: PropTypes.func.isRequired,
    onUserAdmin: PropTypes.func.isRequired,
}

export default MainHeaderView
